export default {
  // Site
  "site.title": "OOPBuy Spreadsheet",
  "site.tagline": "Deutschlands größte OOPBuy Informationsplattform",

  // Nav
  "nav.home": "Startseite",
  "nav.guide": "Guide",
  "nav.einkaufsfuehrer": "Einkaufsführer",
  "nav.categories": "Kategorien",
  "nav.about": "Über uns",
  "nav.versand": "Versand Guide",
  "nav.qc": "QC Guide",
  "nav.compare": "OOPBuy vs Pandabuy",

  // Hero
  "hero.h1": "OOPBuy Spreadsheet Deutschland",
  "hero.h1_sub": "Die ultimative Sammlung für OOPBuy Produkte, QC Bilder und China Shopping Guides.",
  "hero.subtitle": "Finde geprüfte Produkte, beliebte Kategorien und detaillierte Einkaufsanleitungen. Unser OOPBuy Spreadsheet hilft dir schneller, sicherer und günstiger einzukaufen.",
  "hero.cta_primary": "OOPBuy Spreadsheet entdecken",
  "hero.cta_secondary": "Anfänger Guide lesen",

  // Trust Bar
  "trust.item1": "Aktualisierte Produktlisten",
  "trust.item2": "Deutsche Einkaufsanleitungen",
  "trust.item3": "Vergleichstabellen",
  "trust.item4": "QC Qualitätsanalyse",
  "trust.item5": "Versand nach Deutschland erklärt",

  // Why Section
  "why.title": "Warum nutzen Tausende Käufer OOPBuy Spreadsheet?",
  "why.subtitle": "Das OOPBuy Spreadsheet vereinfacht die Suche nach beliebten Produkten. Statt Stunden mit verschiedenen Plattformen zu verbringen, findest du kategorisierte Produkte mit wichtigen Informationen an einem Ort.",
  "why.card1.title": "Große Produktauswahl",
  "why.card1.desc": "Schuhe, Kleidung, Taschen, Accessoires und mehr.",
  "why.card2.title": "Qualitätskontrolle",
  "why.card2.desc": "Lerne QC Bilder richtig zu verstehen.",
  "why.card3.title": "Einkaufswissen",
  "why.card3.desc": "Unsere Guides erklären jeden Schritt.",
  "why.card4.title": "Deutschland Fokus",
  "why.card4.desc": "Versand, Zahlung und Zoll einfach erklärt.",

  // Categories
  "categories.title": "OOPBuy Spreadsheet Kategorien",
  "categories.subtitle": "Entdecke unsere beliebtesten Produktkategorien mit geprüften Links und QC Informationen.",
  "categories.select_placeholder": "Kategorie auswählen...",
  "categories.all_categories": "Alle Kategorien anzeigen",

  // How it works
  "how.title": "So funktioniert OOPBuy Spreadsheet",
  "how.step1": "Produkt finden",
  "how.step2": "QC Bilder prüfen",
  "how.step3": "Preis vergleichen",
  "how.step4": "Sicher bestellen",
  "how.step1_desc": "Durchsuche unsere Datenbank mit tausenden geprüften Produkten aus China.",
  "how.step2_desc": "Analysiere Qualitätskontrollbilder mit unseren detaillierten QC-Guides.",
  "how.step3_desc": "Vergleiche Preise verschiedener Verkäufer und Plattformen in einer Tabelle.",
  "how.step4_desc": "Bestelle sicher mit geprüften Links und unserer Schritt-für-Schritt-Anleitung.",

  // Comparison
  "compare.title": "OOPBuy Spreadsheet vs Andere Plattformen",
  "compare.col1": "Funktion",
  "compare.col2": "OOPBuy Spreadsheet",
  "compare.col3": "Andere Plattformen",
  "compare.row1": "Produktlisten",
  "compare.row2": "Deutsche Guides",
  "compare.row3": "QC Informationen",
  "compare.row4": "Vergleichstabellen",
  "compare.row5": "Anfänger Hilfe",

  // CTA
  "cta.title": "Bereit dein nächstes Produkt zu finden?",
  "cta.subtitle": "Starte jetzt mit dem OOPBuy Spreadsheet und entdecke tausende geprüfte Produkte.",
  "cta.button": "Zum Spreadsheet",

  // Buttons
  "btn.oopbuy_spreadsheet": "OOPBuy Spreadsheet",
  "btn.buy_now": "Buy It Now",

  // Category Names
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies/Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants/Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear/Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  // Article
  "article.read_more": "Vollständigen Guide lesen",
  "article.back_home": "← Zurück zur Startseite",
  "article.more_articles": "Weitere SEO Guides",
  "article.read_guide": "Guide lesen",

  // FAQ
  "faq.title": "Häufig gestellte Fragen",
  "faq.q1": "Was ist ein OOPBuy Spreadsheet?",
  "faq.a1": "Ein OOPBuy Spreadsheet ist eine strukturierte Tabelle mit geprüften Produktlinks aus chinesischen Shops wie Taobao, Weidian und 1688. Es enthält Produktbilder, Preise, QC-Fotos und Bewertungen – alles an einem Ort.",
  "faq.q2": "Ist die Nutzung kostenlos?",
  "faq.a2": "Ja, unser OOPBuy Spreadsheet ist komplett kostenlos. Du kannst alle Produktlisten, Guides und Vergleichstabellen ohne Registrierung nutzen.",
  "faq.q3": "Wie aktuell sind die Produktdaten?",
  "faq.a3": "Unsere Produktlisten werden regelmäßig aktualisiert. Neue Produkte kommen täglich hinzu, und nicht verfügbare Links werden entfernt.",
  "faq.q4": "Funktioniert der Versand nach Deutschland?",
  "faq.a4": "Ja, alle Produkte in unserem Spreadsheet können nach Deutschland versendet werden. Wir erklären in unseren Guides genau, wie Versand, Zoll und Zahlung funktionieren.",
  "faq.q5": "Wie unterscheidet sich OOPBuy von anderen Agenten?",
  "faq.a5": "OOPBuy bietet besonders günstige Versandkosten, eine benutzerfreundliche Oberfläche und exzellenten Kundenservice. In unserer Vergleichstabelle siehst du die Unterschiede zu Pandabuy, Sugargoo und anderen.",

  // Footer
  "footer.disclaimer": "OOPBuy Spreadsheet ist eine unabhängige Informationsplattform. Alle externen Links führen zu kaspreadsheet.com.",
  "footer.copyright": "© 2026 OOPBuy Spreadsheet. Alle Rechte vorbehalten.",
}